import { render } from "./Cashier.vue?vue&type=template&id=4542cadc&scoped=true"
import script from "./Cashier.vue?vue&type=script&lang=js"
export * from "./Cashier.vue?vue&type=script&lang=js"

import "./Cashier.vue?vue&type=style&index=0&id=4542cadc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4542cadc"]])

export default __exports__